// Dubai - prenatal and postnatal personal trainer.
const content = {
    slug: 'prenatal-postnatal-personal-trainer',
    title: 'Prenatal & Postnatal Personal Trainer in Dubai',
    description: (c) =>
        `Prenatal and postnatal personal training in Dubai: safe exercise during pregnancy and recovery after birth, at home. Packages from ${c.money(c.lowest, 0)} a session.`,
    eyebrow: 'Dubai · Pre & postnatal',
    h1: 'Prenatal and Postnatal Personal Trainer in Dubai',
    lead: 'Exercise during pregnancy and after birth is good for you and your baby - as long as it is the right exercise. A trainer experienced with pregnancy and postnatal recovery keeps it safe, at home and on your schedule.',
    image: 'personal-trainer/pregnant-woman-working-out.jpg',
    imageAlt: 'Pregnant woman doing a gentle supported exercise',
    facts: ['Doctor-cleared plans', 'Pelvic floor and core', 'At home, indoors'],
    ctaLabel: 'Request a pre/postnatal trainer',
    matchSummary: 'a prenatal or postnatal personal trainer in Dubai',
    packagesTitle: 'Packages',
    packagesIntro: 'Many mothers start with 14 sessions in late pregnancy or after their postnatal check, then continue. Female trainers available on request.',
    sections: [
        {
            title: 'During pregnancy',
            items: [
                'Strength work adjusted each trimester to support posture and a growing bump.',
                'Pelvic floor and breathing practice to prepare for birth.',
                'Low-impact cardio to keep energy up - indoors through Dubai\'s summer, when overheating is a real risk in pregnancy.',
                'Clear rules on what to avoid, agreed with your doctor.',
            ],
        },
        {
            title: 'After birth',
            tone: 'muted',
            paragraphs: [
                'Most women can start gentle walking and breathing work soon after an uncomplicated birth, and return to structured exercise after their doctor\'s postnatal check, usually around six weeks - later after a caesarean. Your trainer rebuilds from the inside out: breathing, pelvic floor and deep core first, then strength, then intensity.',
                'Sessions can happen while the baby naps, with the baby in the room, or with a partner looking after them. If you have abdominal separation (diastasis recti), your trainer adapts the programme around it.',
            ],
        },
    ],
    faqs: [
        {
            question: 'When can I start exercising after giving birth?',
            answer: 'Gentle walking and breathing exercises early on; structured training after your doctor\'s postnatal check, typically around six weeks, or later after a caesarean section.',
        },
        {
            question: 'Is it safe to train while pregnant in Dubai\'s heat?',
            answer: 'Indoors in air-conditioning, with good hydration and sensible intensity, yes. Avoid outdoor exercise in the summer heat during pregnancy.',
        },
        {
            question: 'Can I have a female trainer?',
            answer: (c) => `Yes - choose a female trainer preference when you request a match (adds ${c.money(c.mods.female, 0)} a session).`,
        },
    ],
    schema: { name: 'Prenatal and Postnatal Personal Training in Dubai' },
}

export default content
